import { connect } from 'react-redux';
import { openDialog } from '../../../../base/dialog/actions';
import { translate } from '../../../../base/i18n/functions';
import AbstractRecordButton from '../AbstractRecordButton';
import { canStopRecording } from '../../../functions';
import StartRecordingDialog from './StartRecordingDialog';
import StopRecordingDialog from './StopRecordingDialog';
import { isNotificationDisplayed } from '../../../../notifications/functions';
/**
 * Button for opening a dialog where a recording session can be started.
 */
class RecordingButton extends AbstractRecordButton {
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _onClick() {
        const { _isRecordingRunning, dispatch } = this.props;
        dispatch(openDialog(_isRecordingRunning ? StopRecordingDialog : StartRecordingDialog));
    }
    /**
     * Overrides toggled state to mark the button when notification is shown.
     *
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isRecordingRunning || this.props.rememberNotificationActive;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code RecordButton} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _fileRecordingsDisabledTooltipKey: ?string,
 *     _isRecordingRunning: boolean,
 *     _disabled: boolean,
 *     visible: boolean
 * }}
 */
export function _mapStateToProps(state) {
    /**
    const abstractProps = _abstractMapStateToProps(state);
    const { toolbarButtons } = state['features/toolbox'];
    const visible = Boolean(toolbarButtons?.includes('recording') && abstractProps.visible);

    return {
        ...abstractProps,
        visible
    };*/
    const { toolbarButtons } = state['features/toolbox'];
    const _isRecordingRunning = canStopRecording(state);
    const _tooltip = _isRecordingRunning
        ? 'dialog.stopRecording'
        : 'dialog.startRecordingLabel';
    const visible = Boolean(toolbarButtons?.includes('recording'));
    const rememberNotificationActive = isNotificationDisplayed(state, 'notify.rememberRecord');
    return {
        _isRecordingRunning,
        _tooltip,
        visible,
        _disabled: false,
        rememberNotificationActive
    };
}
export default translate(connect(_mapStateToProps)(RecordingButton));
